import {
  Button,
  Divider,
  IconButton,
  Icons,
  Stack,
  tokens,
  Typography,
} from '@cast/design-system';
import { EXTERNAL_LINKS } from '@cast/constants';

type RedesignAnnouncementBannerProps = {
  oneClickUrl: string;
  onClose: () => void;
};

export const RedesignAnnouncementBanner = ({
  oneClickUrl,
  onClose,
}: RedesignAnnouncementBannerProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      px={16}
      py={12}
      sx={{
        background: `radial-gradient(
          ellipse 34.56% 169.3% at 19.6% 50%,
          ${tokens.theme.gradient.marketingBannerStop1} 0%,
          ${tokens.theme.gradient.marketingBannerStop2} 50%,
          ${tokens.theme.gradient.marketingBannerStop3} 100%
        )`,
      }}
      data-testid="console-redesign-announcement-banner"
    >
      <Stack direction="row" alignItems="center" gap={8} minWidth={0}>
        <Stack direction="row" alignItems="center" gap={4}>
          <Icons.Star
            size={16}
            color={tokens.theme.fg.structural.primaryOnInverse}
            weight="fill"
          />
          <Typography
            variant="P12B"
            color={tokens.theme.fg.structural.primaryOnInverse}
            noWrap
          >
            We’ve rebuilt the console around your feedback
          </Typography>
        </Stack>
        <Typography
          variant="P12R"
          color={tokens.theme.fg.structural.secondaryOnInverse}
          noWrap
        >
          See what`s new, and read the story from the designers behind it.
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" gap={24} flexShrink={0}>
        <Stack direction="row" alignItems="center" gap={8}>
          <Button
            variant="text"
            component="a"
            href={EXTERNAL_LINKS.castai_new_console_experience}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: tokens.theme.fg.action.primary }}
            testId="console-redesign-announcement-read-more"
          >
            Read about how we redesigned it
          </Button>
          <Divider orientation="vertical" flexItem color="grey.600" />
          <Button
            variant="primary"
            component="a"
            href={oneClickUrl}
            target="_blank"
            rel="noopener noreferrer"
            testId="console-redesign-announcement-cta"
          >
            Take a look around
          </Button>
        </Stack>
        <IconButton
          variant="ghost"
          onClick={onClose}
          sx={{
            background: 'transparent',
            boxShadow: 'none',
            '&:hover': {
              color: tokens.theme.fg.action.onGhost,
              background: 'transparent',
              boxShadow: 'none',
            },
            '&:active': {
              color: tokens.theme.fg.action.onGhost,
              background: 'transparent',
              boxShadow: 'none',
            },
          }}
          testId="console-redesign-announcement-banner-close"
        >
          <Icons.X size={20} color={tokens.theme.fg.action.onPrimary} />
        </IconButton>
      </Stack>
    </Stack>
  );
};
